
import { SetPassWord } from '@/service/index'
import Alert from 'vux/src/components/alert/index.vue'

import { go } from '@/util/router'
import { isNullOrEmpty } from '@/util/util'
import { getItem, setToken } from '@/util/jwtAuth'
export default {
data () {
return {
LoginModel: {UserName: '', OldPwd: '', Pwd: '', ConfirmPwd: ''}
}
},
components: {
Alert
},
created () {
let user = getItem('zds_user')
if (user) {
this.LoginModel.UserName = unescape(user.name)

}
},
mounted () {

},
watch: {
'$route': function (to, from) {

}
},
methods: {
doSubmit () {
let vm = this
if (!isNullOrEmpty(vm.LoginModel.UserName)) {
vm.showAlert('请输入用户名!')
return
}
if (!isNullOrEmpty(vm.LoginModel.OldPwd)) {
vm.showAlert('请输入原密码!')
return
}
if (!isNullOrEmpty(vm.LoginModel.Pwd)) {
vm.showAlert('请输入密码!')
return
}
if (vm.LoginModel.Pwd !== vm.LoginModel.ConfirmPwd) {
vm.showAlert('两次输入密码不一致!')
return
}
SetPassWord(vm.LoginModel, (res) => {
console.log(res)
if (res.code === '1') {
let user = {
uid: '',
name: vm.LoginModel.UserName,
pwd: ''
}
setToken(user)
go('/')
} else {
vm.showToast(res.msg)
}
})
}
}
}



// WEBPACK FOOTER //
// ./src/page/login/password.vue